export default "__VITE_ASSET__CYJfYXev__"